class CookieConsent {

  constructor(options = {}) {
    this.settings = Object.assign({
      appearance: 2, // 2: bar, 3: blocker modal, 4: drawer
      store: null,
      storePrefix: 'gdpr/cookieconsent',
      consentTypes: {
        required: 'cc_required',
        stat: 'cc_stat',
        ads: 'cc_ads',
      },
      toggle: '[data-cc-toggle]',
      // toggleBar: '[data-cc-toggle-bar]',
      // toggleDrawer: '[data-cc-toggle-drawer]',
      toggleModal: '[data-cc-toggle-modal]',
      accept: '[data-cc-accept]',
      reject: '[data-cc-reject]',
      acceptAll: '[data-cc-accept-all]',
      consentInput: 'input[name="consent_type[]"]',
    }, options);

    // this.enabledConsentTypes = {
    //   required: this.settings.consentTypes.required, // always on
    // };

    this.store = this.settings.store;

    this.consentTypes = this.settings.consentTypes;

    this.enabledConsentTypes = {};
    this.addConsent('required'); // always on

    this.isBarOpened = false;
    this.isModalOpened = false;
    this.isDrawerOpened = false;

    // // this.boundToggleMain = e => this.onToggleMain(e);
    // this.boundChangeConsent = e => this.onChangeConsent(e);
    // this.boundAccept = e => this.onAccept(e);
    // this.boundAcceptAll = e => this.onAcceptAll(e);
    // this.boundReject = e => this.onReject(e);

    // // main toggle (based on type)
    // Array.from(document.querySelectorAll(this.settings.toggle)).forEach(el => {
    //   el.addEventListener('click', e => {
    //     e.preventDefault();
    //     this.toggleMain();
    //   }, false);
    // });

    // main toggle (based on type)
    this.live('click', this.settings.toggle, (el, e) => {
      e.preventDefault();
      this.toggleMain();
    });

    // // toggle cookie bar
    // this.live('click', this.settings.toggleBar, (el, e) => {
    //   e.preventDefault();
    //   this.toggleBar();
    // });
    
    // toggle cookie modal
    this.live('click', this.settings.toggleModal, (el, e) => {
      e.preventDefault();
      this.toggleModal();
    });

    // change consent checkbox
    // this.live('change', this.settings.changeConsent, (el, e) => {
    this.live('change', this.settings.consentInput, (el, e) => {
      const inputName = el.getAttribute('name') || null;
      if (!inputName) {
        return new Error('CookieConsent.onChange() : Interactive element has to have a name.');
      }
      let promise;
      if (el.checked) {
        promise = this.addConsent(el.value);
      } else {
        promise = this.removeConsent(el.value);
      }
      promise
        .then(() => {
          // CMS.DataStore.dispatch(`${this.settings.storePrefix}/consentTypes`, this.enabledConsentTypes);
          this.store.dispatch(`${this.settings.storePrefix}/consentTypes`, this.enabledConsentTypes);
        })
        .catch(err => console.error(err));
    });

    // accept current selected
    this.live('click', this.settings.accept, (el, e) => {
      e.preventDefault();
      this.acceptConsent();
    });

    // accept all
    this.live('click', this.settings.acceptAll, (el, e) => {
      e.preventDefault();
      this.acceptConsent({ all: true });
    });

    // reject
    this.live('click', this.settings.reject, (el, e) => {
      e.preventDefault();
      this.rejectConsent();
    });
  }

  addConsent(type) {
    return new Promise((resolve, reject) => {
      // if (typeof this.settings.consentTypes[type] === 'undefined') {
      if (typeof this.consentTypes[type] === 'undefined') {
        console.log('settings:', this.settings);
        return reject(`CookieConsent.addConsent() : invalid type: ${type}`);
      }
      // this.enabledConsentTypes[type] = this.settings.consentTypes[type];
      this.enabledConsentTypes[type] = this.consentTypes[type];
      resolve();
    });
  }
  
  removeConsent(type) {
    return new Promise((resolve, reject) => {
      if (typeof this.enabledConsentTypes[type] === 'undefined') {
        return reject(`CookieConsent.addConsent() : type "${type}" is not enabled`);
      }
      delete this.enabledConsentTypes[type];
      resolve();
    });
    // if (
    //   typeof this.settings.consentTypes[type] !== 'undefined' &&
    //   typeof this.enabledConsentTypes[type] !== 'undefined'
    // ) {
    //   delete this.enabledConsentTypes[type];
    // }
  }

  toggleMain() {
    switch(parseInt(this.settings.appearance)) {
      case 2:
        this.toggleBar();
        break;
      case 3:
        this.toggleModal();
        break;
      case 4:
        this.toggleDrawer();
        break;
    }
  }

  toggleBar() {
    if (this.isBarOpened) {
      this.closeBar();
    } else {
      this.openBar();
    }
  }

  toggleModal() {
    if (this.isModalOpened) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }

  toggleDrawer() {
    if (this.isDrawerOpened) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  openBar() {
    // CMS.DataStore.dispatch(`${this.settings.storePrefix}/bar`, {
    this.store.dispatch(`${this.settings.storePrefix}/bar`, {
      action: 'open',
    });
    this.isBarOpened = true;
  }

  closeBar() {
    // CMS.DataStore.dispatch(`${this.settings.storePrefix}/bar`, {
    this.store.dispatch(`${this.settings.storePrefix}/bar`, {
      action: 'close',
    });
    this.isBarOpened = false;
  }
  
  openModal() {
    // auto-select already enabled consent types
    // Array.from(document.querySelectorAll(this.settings.changeConsent)).forEach(inputEl => {
    //   if (typeof this.enabledConsentTypes[inputEl.value] !== 'undefined') {
    //     inputEl.checked = true;
    //   } else {
    //     inputEl.checked = false;
    //   }
    // });
    // CMS.DataStore.dispatch(`${this.settings.storePrefix}/modal`, {
    this.store.dispatch(`${this.settings.storePrefix}/modal`, {
      action: 'open',
      acceptedTypes: this.enabledConsentTypes,
    });
    this.isModalOpened = true;
  }

  closeModal() {
    // CMS.DataStore.dispatch(`${this.settings.storePrefix}/modal`, {
    this.store.dispatch(`${this.settings.storePrefix}/modal`, {
      action: 'close',
      acceptedTypes: this.enabledConsentTypes,
    });
    this.isModalOpened = false;
  }

  openDrawer() {
    // // auto-select already enabled consent types
    // Array.from(document.querySelectorAll(this.settings.changeConsent)).forEach(inputEl => {
    //   if (typeof this.enabledConsentTypes[inputEl.value] !== 'undefined') {
    //     inputEl.checked = true;
    //   } else {
    //     inputEl.checked = false;
    //   }
    // });
    // CMS.DataStore.dispatch(`${this.settings.storePrefix}/drawer`, {
    this.store.dispatch(`${this.settings.storePrefix}/drawer`, {
      action: 'open',
      acceptedTypes: this.enabledConsentTypes,
    });
    this.isDrawerOpened = true;
  }
  
  closeDrawer() {
    // CMS.DataStore.dispatch(`${this.settings.storePrefix}/drawer`, {
    this.store.dispatch(`${this.settings.storePrefix}/drawer`, {
      action: 'close',
      acceptedTypes: this.enabledConsentTypes,
    });
    this.isDrawerOpened = false;
  }

  acceptConsent(options = {}) {
    const settings = Object.assign({
      all: false,
    }, options);

    const promises = [];
    if (settings.all) {
      // this.enabledConsentTypes = this.settings.consentTypes;
      for (const [key, cookieName] of Object.entries(this.consentTypes)) {
        promises.push(this.addConsent(key));
      }
      // this.enabledConsentTypes = this.consentTypes;
    }

    if (promises.length > 0) {
      Promise.all(promises)
        .then(() => {
          // CMS.DataStore.dispatch(`${this.settings.storePrefix}/accept`, this.enabledConsentTypes);
          this.store.dispatch(`${this.settings.storePrefix}/accept`, this.enabledConsentTypes);
        })
        .catch(err => console.error(err));
    } else {
      // CMS.DataStore.dispatch(`${this.settings.storePrefix}/accept`, this.enabledConsentTypes);
      this.store.dispatch(`${this.settings.storePrefix}/accept`, this.enabledConsentTypes);
    }

    switch(parseInt(this.settings.appearance)) {
      case 2:
        if (this.isBarOpened) {
          this.closeBar();
        }
        if (this.isModalOpened) {
          this.closeModal();
        }
        break;
      case 3:
        if (this.isModalOpened) {
          this.closeModal();
        }
        break;
      case 4:
        if (this.isDrawerOpened) {
          this.closeDrawer();
        }
        break;
    }
  }

  rejectConsent() {
    // remove all except required
    let promises = [];
    for (const [key, cookieName] of Object.entries(this.enabledConsentTypes)) {
      if (key !== 'required') {
        promises.push(this.removeConsent(key));
      }
    }

    Promise.all(promises)
      .then(() => {
        // CMS.DataStore.dispatch(`${this.settings.storePrefix}/accept`, this.enabledConsentTypes);
        this.store.dispatch(`${this.settings.storePrefix}/accept`, this.enabledConsentTypes);
      })
      .catch(err => console.error(err));

    switch(parseInt(this.settings.appearance)) {
      case 2:
        if (this.isBarOpened) {
          this.closeBar();
        }
        if (this.isModalOpened) {
          this.closeModal();
        }
        break;
      case 3:
        if (this.isModalOpened) {
          this.closeModal();
        }
        break;
      case 4:
        if (this.isDrawerOpened) {
          this.closeDrawer();
        }
        break;
    }
  }

  live(eventName, el, callback, context = null) {
    const ctx = context || document;
    ctx.addEventListener(eventName, function(e) {
      let currentEl = e.target;
      let isMatch = false;
      do {
        isMatch = (typeof el === 'string') ? currentEl.matches(el) : currentEl === el;
        if (isMatch) {
          callback.call(null, currentEl, e);
          break;
        }
        currentEl = currentEl.parentElement;
        if (!currentEl) {
          break;
        }
      } while(!isMatch);
    }, false);
  }

}

export default CookieConsent;
